import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-video-instructions',
  templateUrl: './video-instructions.component.html',
  styleUrls: ['./video-instructions.component.scss'],
  standalone: false
})
export class VideoInstructionsComponent {
  @Input() videoWidth: number = 0;

  constructor(private translate: TranslateService) {}

  get ttsText(): string {
    return [
      this.translate.instant('video_instructions.title'),
      this.translate.instant('video_instructions.tap_arrow'),
      this.translate.instant('video_instructions.full_screen'),
      this.translate.instant('video_instructions.change_language'),
      this.translate.instant('video_instructions.change_speed'),
      this.translate.instant('video_instructions.subtitles'),
    ].join('. ');
  }


  calcVideoWidth(width: number): number | null {
    let returnWidth = width > 0 ? width : null;
    // videoWidth > 0 ? videoWidth - 20 : null
    if (width) {
      switch (true) {
        case width > 600:
        case width > 450:
          returnWidth = width - 40;
          break;
        case width > 300:
          returnWidth = width - 30;
          break;
        case width < 250:
          returnWidth = width - 20;
          break;
      }
    }
    return returnWidth;
  }
}
